var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5C6.10745 0.5 0.5 6.10745 0.5 13C0.5 19.8925 6.10745 25.5 13 25.5C19.8925 25.5 25.5 19.8925 25.5 13C25.5 6.10745 19.8925 0.5 13 0.5ZM13.8203 19.25H12.1797V10.5625H13.8203V19.25ZM13 8.96875C12.3906 8.96875 11.8906 8.46875 11.8906 7.85937C11.8906 7.25 12.3906 6.75 13 6.75C13.625 6.75 14.1094 7.23437 14.1094 7.85937C14.1094 8.48437 13.625 8.96875 13 8.96875Z",
    fill: "#FF2124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.6828e5e680f1f6ba205297f7959882d2.svg";
export { ForwardRef as ReactComponent };